/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rwezamenyo 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */

module.exports = {
  "Kabuguru I": [
    "Muhoza",
    "Muhuza",
    "Mumararungu",
    "Murambi"
  ],
  "Kabuguru II": [
    "Buhoro",
    "Gasabo",
    "Mutara",
    "Ubusabane"
  ],
  "Rwezamenyo I": [
    "Abatarushwa",
    "Indatwa",
    "Inkerakubanza",
    "Intwari"
  ],
  "Rwezamenyo II": [
    "Amahoro",
    "Umucyo",
    "Urumuri"
  ]
};
